export const BOOK_DEMO_URL = "https://calendly.com/cybermondirector/30min";
